(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("axios-offline", [], factory);
	else if(typeof exports === 'object')
		exports["axios-offline"] = factory();
	else
		root["axios-offline"] = factory();
})(window, function() {
return 